module.exports = __webpack_public_path__ + "tw.eb916f30af7e47d1b065.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tw.svg
// module chunks = styles